export function isVowel(char) {
  // 'y' is not included because this function is used for determining whether
  // to put 'a' or 'an' before a word, and words starting with 'y' rarely use it
  // as a vowel.
  return ['a', 'e', 'i', 'o', 'u'].includes(char.toLowerCase())
}
